import Environment from "../../utils/Environement";
import KeytchensApi from "../api/KeytchensApi";
import { StoreActionType } from "../constant/ActionConstant";
import AppDispatcher from "../dispatcher/AppDispatcher";
import Service from "../model/service/Service";
import { getAuth } from "firebase/auth";

class KeytchensActionCreator {
  private api: KeytchensApi;

  constructor() {
    this.api = new KeytchensApi(Environment.isDev, Environment.isPopina);
  }

  async loadService() {
    const auth = getAuth()
    const useruid = auth.currentUser?.uid
    if (useruid === undefined) {
      throw new Error("error firebase not connected");
    }
    try {
      const res = await this.api.loadService(useruid);
      const service = res?.data;

      const serviceUser = service
        ? new Service(service)
        : new Service();

      AppDispatcher.dispatch({
        type: StoreActionType.SET_KEYTCHENS_SERVICE,
        data: serviceUser
      });
    } catch (e) {
      throw e;
    }
  }

  async connectService(companyUuid: string) {
    const auth = getAuth()
    const useruid = auth.currentUser?.uid
    if (useruid === undefined) {
      throw new Error("error firebase not connected");
    }
    try {
      const res = await this.api.connectService(companyUuid, useruid);
      const data = res?.data?.service;
      const service = new Service(data);

      AppDispatcher.dispatch({
        type: StoreActionType.SET_KEYTCHENS_SERVICE,
        data: service
      });
    } catch (e) {
      throw e;
    }
  }

  async disconnectService() {
    const auth = getAuth()
    const useruid = auth.currentUser?.uid
    if (useruid === undefined) {
      throw new Error("error firebase not connected");
    }
    try {
      await this.api.disconnectService(useruid);
      AppDispatcher.dispatch({
        type: StoreActionType.SET_KEYTCHENS_SERVICE,
        data: new Service()
      });
    } catch (e) {
      throw e;
    }
  }

}

const keytchensActionCreator = new KeytchensActionCreator();
export default keytchensActionCreator;
